import React from 'react';
import {
  withStyles,
  Input,
  Typography,
  InputAdornment,
} from '@material-ui/core';
// @ts-ignore
import cx from 'classnames';
import SearchIcon from '@material-ui/icons/Search';

export interface EeInputProps {
  type?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  readOnly?: boolean;
  sideLabel?: string;
  label?: string;
  classes?: object;
  className?: string;
  inputClassName?: string;
  multiline?: boolean;
  error?: boolean;
  name?: string;
  style?: object;
  ref?: React.ReactNode;
  inputProps?: object;
  errorText?: string;
  notFullWidth?: boolean;
  search?: boolean;
  descriptionClass?: string;
  children?: React.ReactNode;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onKeyDown?: () => void;
  onKeyUp?: () => void;
  onClear?: () => void;
}

const inputStyles = {
  error: {
    borderColor: '#f36047',
    backgroundColor: '#fff',
    color: '#f36047',
  },
  multiline: {
    height: 'auto',
    maxHeight: '100%',
  },
  inputMultiline: {
    height: 'auto',
    minHeight: 60,
  },
};

const renderInputSideItems = (
  sideLabel: {} | null | undefined,
  search: boolean | undefined,
) => {
  return (
    <>
      {search && (
        <InputAdornment disableTypography position="start">
          <SearchIcon />
        </InputAdornment>
      )}
      {sideLabel && <span className="ee-input--side-label">{sideLabel}</span>}
    </>
  );
};

const InputBase: React.FC<EeInputProps> = ({
  type,
  placeholder,
  value,
  disabled,
  readOnly,
  sideLabel,
  label,
  classes,
  className,
  inputClassName,
  multiline,
  error,
  name,
  style,
  ref,
  inputProps,
  errorText,
  notFullWidth,
  search,
  descriptionClass,
  onFocus,
  onBlur,
  onChange,
  onKeyDown,
  onKeyUp,
  onClear,
  ...rest
}) => (
  <div
    className={cx('position-relative', { 'w-100': !notFullWidth }, className)}
  >
    <Input
      // @ts-ignore
      ref={ref}
      classes={classes}
      className={cx(inputClassName, 'input-field overflow-hidden')}
      value={value}
      type={type || 'text'}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      disabled={disabled}
      readOnly={!!readOnly}
      disableUnderline
      startAdornment={renderInputSideItems(sideLabel, search)}
      multiline={multiline}
      rows={multiline ? 3 : undefined}
      error={error}
      name={name}
      style={style}
      inputProps={inputProps}
      {...rest}
    />
    {error && errorText && (
      <span className="ee-input-error-text">{errorText}</span>
    )}
  </div>
);

export const EeInput = withStyles(inputStyles)((props: any) => {
  const {
    label,
    className,
    errorText,
    labelStyle,
    disabled,
    description,
    descriptionClass,
  } = props;
  if (label)
    return (
      <div
        className={cx('relative d-flex', className, {
          'is-disabled': disabled,
        })}
      >
        {description ? (
          <div className="d-flex flex-column">
            <Typography
              variant="subtitle1"
              className={cx('ee-label text-ellipsis', { 'mb-2': errorText })}
              style={labelStyle}
              title={label}
            >
              {label}
            </Typography>

            <Typography className={`ee-desc fs-12 ${descriptionClass || ''}`}>
              {description}
            </Typography>
          </div>
        ) : (
          <Typography
            variant="subtitle1"
            className={cx('ee-label text-ellipsis', { 'mb-2': errorText })}
            style={labelStyle}
            title={label}
          >
            {label}
          </Typography>
        )}
        {<InputBase {...props} />}
      </div>
    );
  return <InputBase {...props} />;
});
